import React, { useEffect, useState } from "react";
import { ModalHeader, ModalBody, Button } from "reactstrap";
import { connect } from "react-redux";
import { compose } from "redux";
import AddUsersEnhancer from "./enhancer/AddUsersEnhancer";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { addSubUser, editSubUser } from "services/usersServices";
import navigationAction from "redux/navigation/actions";
import Loader from "components/Loader";
// import ConformationModalUser from "components/common/ConformationModalUser";
import _ from "lodash";
const { success, error } = navigationAction;

function AddUsers(props) {
  const {
    closeAddModal,
    refresh,
    getFieldProps,
    errors,
    values,
    touched,
    submitCount,
    handleSubmit,
    token,
    user,
    setValues,
    isValid,
    editUser,
    // history,
    isEditRequest
  } = props;
  const [loading, setLoading] = useState(false);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  // const [tempFlag, setTempFlag] = useState(false);
  // const [warningModal, setWarningModal] = useState(false);
  let isSubscribed = user?.subscription_package?.subscription_id ? true : false;

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };
  // console.log("user", user);
  useEffect(() => {
    if (isEditRequest === true) {
      setValues({ ...editUser });
    }
  }, []);

  async function handleAddUser(e) {
    handleSubmit();
    if (errors) {
      setSubmitDisabled(false);
    }
  
    if (isValid) {
      isEditRequest
        ? await editSubUser(token, editUser._id, values).then(response => {
            if (response.success) {
              closeAddModal();
              success(response.message);
              setSubmitDisabled(false);
              setLoading(false);
              refresh();
            } else {
              error(response.message);
              setSubmitDisabled(false);
              setLoading(false);
            }
          })
        : await addSubUser(token, values).then(response => {
            if (response.success) {
              closeAddModal();
              success(response.message);
              setSubmitDisabled(false);
              setLoading(false);
              refresh();
            } else {
              error(response.message);
              setSubmitDisabled(false);
              setLoading(false);
            }
          });
    }
    setSubmitDisabled(false);
    setLoading(false);
  }

  return (
    <div>
      <>
        <ModalHeader toggle={closeAddModal} className="modal-lg">
          {isSubscribed || user?.is_admin
            ? isEditRequest
              ? "Edit  User"
              : "Add User"
            : "Purchase Subscription"}
        </ModalHeader>
        <ModalBody className="modal-lg">
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="name">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control react-form-input custom-input-class"
                  placeholder="Enter name"
                  {...getFieldProps("name")}
                />
                <Error field="name" />
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="email">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control react-form-input custom-input-class"
                  placeholder="Enter email"
                  {...getFieldProps("email")}
                />
                <Error field="email" />
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <label htmlFor="phone_number">
                  Phone Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control react-form-input custom-input-class"
                  placeholder="Enter phone number"
                  {...getFieldProps("phone_number")}
                />
                <Error field="phone_number" />
              </div>
            </div>
            {user?.is_admin ? (
              <></>
            ) : (
              <>
                <div className="col-12">
                  <div className="form-group d-flex ml-1">
                    <div className="pl-0 custom-control custom-checkbox  is-admin-checkbox">
                      <label htmlFor="is_admin">Is Admin: </label>
                      <input
                        type="checkbox"
                        className="react-form-input permission-check-size cursor-pointer "
                        checked={values.is_admin}
                        placeholder="Enter phone number"
                        {...getFieldProps("is_admin")}
                      />
                    </div>
                    <Error field="is_admin" />
                  </div>
                </div>
              </>
            )}
            {console.log(isSubmitDisabled, "check175")}
            <div className="col-6 text-center mt-4 pr-2">
              <button
                disabled={isSubmitDisabled}
                onClick={e => {
                  e.preventDefault();
                  setSubmitDisabled(true);
                  setLoading(true);
                  handleAddUser(e);
                }}
                className="btn btn-info w-100 btn-bordered"
                type="button"
              >
                {isEditRequest ? "Edit" : "Add"}
              </button>
            </div>
            {console.log(isSubmitDisabled, "check176")}
            <div className="col-6 text-center mt-4 pl-2">
              <Button
                onClick={() => closeAddModal()}
                className="btn btn-dark w-100 btn-bordered"
                type="button"
              >
                Cancel
              </Button>
            </div>
          </div>
        </ModalBody>
        {loading && <Loader />}
      </>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  withRouter,
  AddUsersEnhancer,
  connect(mapStateToProps, { error, success })
)(AddUsers);
